import { render } from "./FormTrainingItemIndicator.vue?vue&type=template&id=141e4c1b&scoped=true&ts=true"
import script from "./FormTrainingItemIndicator.vue?vue&type=script&lang=ts"
export * from "./FormTrainingItemIndicator.vue?vue&type=script&lang=ts"

import "./FormTrainingItemIndicator.vue?vue&type=style&index=0&id=141e4c1b&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-141e4c1b"]])

export default __exports__